var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.00297326 32.4461C-0.240093 14.4508 14.4515 -0.240081 32.4476 0.00297312C49.7069 0.242951 63.7601 14.2955 63.997 31.5569C64.2431 49.5522 49.5546 64.2431 31.5554 63.997C14.2962 63.757 0.242962 49.7045 0.00297326 32.4461ZM51.676 50.4966C51.7596 50.4627 51.8347 50.4107 51.896 50.3444C56.5173 45.3538 59.0824 38.8015 59.0772 32C59.0772 17.0491 46.9116 4.88867 31.9354 4.92559C16.9591 4.96251 4.67507 17.4921 4.92582 32.4615C5.03581 39.1028 7.5929 45.47 12.107 50.3429C12.1683 50.4091 12.2434 50.4611 12.327 50.4951C12.4107 50.5291 12.5007 50.5443 12.5909 50.5396C12.681 50.5349 12.769 50.5104 12.8486 50.4679C12.9282 50.4254 12.9975 50.3659 13.0516 50.2936C14.4277 48.4939 16.1128 46.9531 18.0283 45.7433C21.945 43.2297 26.9079 41.8452 32.0015 41.8452C37.0951 41.8452 42.058 43.2297 45.9747 45.7433C47.8903 46.9537 49.5754 48.495 50.9514 50.2952C51.0055 50.3675 51.0748 50.427 51.1544 50.4695C51.234 50.512 51.322 50.5364 51.4122 50.5411C51.5023 50.5458 51.5924 50.5306 51.676 50.4966ZM24.1209 17.7145C26.1084 15.6453 28.9055 14.5067 31.999 14.5067C35.0721 14.5067 37.8645 15.653 39.8599 17.733C41.8804 19.8407 42.8656 22.6757 42.6334 25.7171C42.1691 31.763 37.408 36.6933 31.999 36.6933C26.59 36.6933 21.8195 31.763 21.3646 25.7156C21.1403 22.6449 22.1333 19.7837 24.1209 17.7145Z",
    fill: "#8D264B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/Person.28f8fe5574c3c1ea9e77535a9bce19f4.svg";
export { ForwardRef as ReactComponent };